import { can } from "modules/settings/accessRoles";
import React, {useEffect} from "react";
import {
  Box,
  TextField as MuiTextField,
  Dialog,
  DialogContent,
  DialogTitle,
  Slide,
  IconButton,
  Chip,
  Button,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { EditableTable } from "components/EditableTable";

import StatusTag from "../../apl/components/StatusTag";
// Redux Components
import PropTypes from "prop-types";
import {connect, useDispatch} from "react-redux";
import { useSearchParams } from "react-router-dom";
import { get as getProperties } from "../api/actions";
import { getPropertyGroups } from "../api/actions";
import {get as getPropertyStatuses } from "modules/propertyStatus/api/actions"
import Form from "./Form";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Table(props) {
  const [searchQuery, setSearchQuery] = React.useState("");
  const [focus, setFocus] = React.useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const dispatch = useDispatch();


  const handleSearchTargetChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const CurrentLookupTypeButton = () => {
    return (
      <IconButton>
        <SearchIcon mr={2} />
      </IconButton>
    );
  };

  const PropertyRowStatusStyling = (property) => {
    // Horidly inefficiant but theres no better way to access this in the context i can think of
    property.propertyStatus = (
      <>
        <StatusTag
          type={"propertyStatus"}
          isLoading={props.apl.genericTypes.propertyStatus.isLoading}
          typeId={property.statusId}
          showTitle={false}
          condensed={true}
        />
      </>
    );

    if (property.groupName) {
      property.groupName = (
        <Chip
          label={property.groupName}
          size="small"
          style={{
            backgroundColor: property.groupColorTag ? `#${property.groupColorTag}` : 'transparent',
            color: property.groupColorTag ? '#ffffff' : '#000000',
            border: property.groupColorTag ? 'none' : '1px solid #ccc',
            fontWeight: '500'
          }}
          variant={property.groupColorTag ? "filled" : "outlined"}
        />
      );
    }

    return {};
  };

  const canAdd = can(props.user.details, "editRecords");

  const setSearchFocus = () => {
    setFocus(true);
  }
  const unsetSearchFocus = () => {
    setFocus(false);
  }

  const getCurrentGroupFilter = () => {
    const groupId = searchParams.get('groupId');
    console.log(groupId, 'groupId')
    if (!groupId) return null;
    const propertyGroups = props.propertyGroups?.items || [];
    console.log(propertyGroups, 'propertyGroups')
    const group = propertyGroups.find(g => g.id === parseInt(groupId));
    return group;
  };

  const handleClearGroupFilter = () => {
    setSearchParams({});
    props.getProperties(null, null);
  };

  useEffect(()=>{
    dispatch(getPropertyStatuses())
    if (props.getPropertyGroups) {
      props.getPropertyGroups();
    }
  },[])

  const SearchBar = () => {
    return (
      <Box sx={{ width: '100%', mt: 2, mb: 2 }}>
        {
          focus ?
            <MuiTextField
              id={"searchTarget"}
              type={"text"}
              placeholder={"Search by any property object field"}
              onChange={handleSearchTargetChange}
              autoFocus={"true"}
              onBlur={unsetSearchFocus}
              inputRef={text => text && text.focus()}
              name={"searchTarget"}
              defaultValue={searchQuery}
              fullWidth
              size={"small"}
              variant={"outlined"}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{ endAdornment: <CurrentLookupTypeButton /> }}
              sx={{ width: '100%', margin: 0 }}
            ></MuiTextField>
            :
            <MuiTextField
              id={"searchTarget"}
              type={"text"}
              placeholder={"Search by any property object field"}
              onChange={handleSearchTargetChange}
              onClick={setSearchFocus}
              name={"searchTarget"}
              defaultValue={searchQuery}
              fullWidth
              size={"small"}
              variant={"outlined"}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{ endAdornment: <CurrentLookupTypeButton /> }}
              sx={{ width: '100%', margin: 0 }}
            ></MuiTextField>
        }
      </Box>
    );
  };

  const FilterChip = () => {
    const currentGroup = getCurrentGroupFilter();
    console.log(currentGroup, 'currentGroup');
    
    if (!currentGroup) return null;

    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <Chip
          label={currentGroup?.name || 'No Filters Applied'}
          style={{
            backgroundColor: currentGroup?.bgColorTag ? `#${currentGroup?.bgColorTag}` : 'transparent',
            color: currentGroup?.bgColorTag ? '#ffffff' : '#000000',
            border: currentGroup?.bgColorTag ? 'none' : '1px solid #ccc',
            fontWeight: '500'
          }}
          variant={currentGroup?.bgColorTag ? "filled" : "outlined"}
          size="small"
        />
        <Button
          variant="outlined"
          size="small"
          startIcon={<ClearIcon />}
          onClick={handleClearGroupFilter}
          sx={{ 
            textTransform: 'none',
            fontSize: '0.75rem',
            minWidth: 'auto',
            px: 1
          }}
        >
          Clear Filter
        </Button>
      </Box>
    );
  };

  // Table Stuff:
  const fieldTitles = [
    "Name",
    "Status",
    "GL Code",
    "Developer",
    "Property Manager",
    "Property Group",
    "Site Plan",
    "Units"
  ];
  const fieldTypes = ["label", "label", "label", "label", "label", "label", "sitePlanPdfBtn" , "label"];
  const fieldNames = [
    "name",
    "propertyStatus",
    "glCode",
    "developerName",
    "propertyManagerName",
    "groupName",
    "sitePlanSignedUrl",
    "totalUnits",
  ];

  const onSelected = (item) => {
    window.open(
      "/property/" + item.uuid + "/" + item.id + "/" + item.propertyManagerId
    );
  };

  const onUpdate = () => {
    hide();
  };

  const [display, setDisplay] = React.useState(false);

  const show = () => {
    props.properties.data.property = {}; // TODO: clear property on popup show
    setDisplay(true);
  };

  const hide = () => {
    setDisplay(false);
  };

  const NewDialog = () => {
    return (
      <Dialog
        open={display}
        TransitionComponent={Transition}
        fullWidth={"lg"}
        maxWidth={"lg"}
        keepMounted
        onClose={hide}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">New Property</DialogTitle>
        <DialogContent>
          <Form onUpdate={onUpdate} onCancel={hide} />
        </DialogContent>
      </Dialog>
    );
  };

  // Create filtered data array while maintaining proper structure for skeleton loading
  const getFilteredProperties = () => {
    // Initialize with proper structure, same as account table
    let filteredProperties = { 
      items: [], 
      toUpdate: [], 
      toDelete: [] 
    };
    
    // If loading or no data, return empty structure to allow skeleton loading
    if (props.properties.isLoading || !props.properties.data.propertiesList || !props.properties.data.propertiesList.items) {
      return filteredProperties;
    }
    
    // Start with a copy of all items
    let itemsToFilter = JSON.parse(JSON.stringify(props.properties.data.propertiesList.items));
    
    // Apply search query filtering
    if (searchQuery !== "") {
      itemsToFilter = itemsToFilter.filter(item => {
        return (item.name != null && item.name.toUpperCase().includes(searchQuery.toUpperCase())) ||
          (item.city != null && item.city.toUpperCase().includes(searchQuery.toUpperCase())) ||
          (item.state != null && item.state.toUpperCase().includes(searchQuery.toUpperCase())) ||
          (item.zip != null && item.zip.toUpperCase().includes(searchQuery.toUpperCase())) ||
          (item.statusDescription != null && item.statusDescription.toUpperCase().includes(searchQuery.toUpperCase())) ||
          (item.totalUnits != null && item.totalUnits.toString().includes(searchQuery)) ||
          (item.developerName != null && item.developerName.toUpperCase().includes(searchQuery.toUpperCase())) ||
          (item.glCode != null && item.glCode.toUpperCase().includes(searchQuery.toUpperCase())) ||
          (item.ownerName != null && item.ownerName.toUpperCase().includes(searchQuery.toUpperCase()));
      });
    }
    
    filteredProperties.items = itemsToFilter;
    return filteredProperties;
  };

  const toShowAll = getFilteredProperties();


  return (
    <div style={{ width: '100%', margin: 0, padding: 0 }}>
        <NewDialog />
        <SearchBar />
        <FilterChip />
        <EditableTable
          canSearch={false}
          readOnly={!canAdd}
          canSave={canAdd}
          canAddItems={canAdd}
          conditionalStylingMethod={PropertyRowStatusStyling}
          isLoading={props.properties.isLoading}
          newItemCreationMethod={show}
          handleRowClickParentMethod={onSelected}
          objectArray={toShowAll}
          canExport={true}
          fieldTitles={fieldTitles}
          fieldTypes={fieldTypes}
          fieldNames={fieldNames}
        />
    </div>
  );
}

Table.propTypes = {
  user: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  properties: PropTypes.object.isRequired,
  getProperties: PropTypes.func.isRequired,
  getPropertyGroups: PropTypes.func,
};

function State(state) {
  return {
    user: state.user,
    apl: state.apl,
    search: state.search,
    properties: state.properties,
    propertyGroups: state.properties.propertyGroups,
  };
}

export default connect(State, { getProperties, getPropertyGroups })(Table);
